// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* theme color */\n.advert[data-v-2159bc26] {\n  width: 100%;\n}\n.advert[data-v-2159bc26]:hover {\n  opacity: 0.8;\n}\n.advert a[data-v-2159bc26] {\n  display: block;\n}\n.advert a img[data-v-2159bc26] {\n  width: 100%;\n  height: auto;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
